<ng-template #regionTemplate let-row>
  <app-region-display [regionId]="anomalyRegionId(row)"></app-region-display>
</ng-template>

<ng-template #cropTemplate let-row>
  {{ row | serverTranslate:'cropName' }}
</ng-template>

<ng-template #anomalyTypeTemplate let-row>
  <span class="anomaly-type-badge" [ngStyle]="anomalyTypeBadgeStyle(row)">{{ anomalyTypeCell(row) }}</span>
</ng-template>

<ng-template #productSourceTemplate let-row>
  <span class="anomalies-cell-source">{{ productSourceCell(row) }}</span>
</ng-template>

<ng-template #anomaliesTemplate let-row let-fieldName="fieldName">
  {{ row?.anomalyPolygon?.[fieldName] | dateFormatLang:translate?.currentLang }}
</ng-template>

<ng-template #requestNumberTemplate let-row>
  @if (row?.linkedBidId) {
    <a
      class="anomalies-request-number-link"
      [routerLink]="['/crop-monitoring/requests/edit', row.linkedBidId]"
      (click)="$event.stopPropagation()"
    >{{ row.linkedBidNumber }}</a>
  } @else {
    <span>—</span>
  }
</ng-template>

<ng-template #actionsTemplate let-row>
  <div class="flex gap-2 flex-row">
    <button
      pButton
      type="button"
      icon="pi pi-map-marker"
      class="p-button-text p-button-sm action-btn"
      [pTooltip]="'GO_TO_POINT' | translate"
      (click)="onZoomToPoint.emit(row); $event.stopPropagation()">
    </button>
    <button
      pButton
      type="button"
      icon="pi pi-external-link"
      class="p-button-text p-button-sm action-btn"
      [pTooltip]="'Field' | translate"
      (click)="openEditModal(row); $event.stopPropagation()">
    </button>
  <button
        pButton
        type="button"
        icon="pi pi-camera"
        class="p-button-text p-button-sm action-btn"
        [disabled]="!row?.anomalyPolygon?.fieldId"
        [pTooltip]="'Create request' | translate"
        (click)="openCreateBidDialog(row, $event)">
      </button>
    </div>
</ng-template>

@if (columnsReady()) {
  @if (compactLayout) {
    <div class="anomalies-list-embedded">
      <app-dynamic-data-table
        [(loading)]="loading"
        [service]="service"
        [getAllMethod]="getAllMethod"
        [getTotalMethod]="getTotalMethod"
        [filter]="filtersParams"
        [toggleFilter]="toggleFilter"
        [storageKey]="''"
        [columns]="tableColumns()"
        [defaultParams]="defaultTableParams"
      ></app-dynamic-data-table>
    </div>
  } @else {
    <list-table-without-filters-wrapper
      [title]="'' | translate"
      [columns]="tableColumns()"
      [service]="service"
      [getAllMethod]="getAllMethod"
      [getTotalMethod]="getTotalMethod"
      [filtersForms]="filtersForms"
      [isLoading]="loading"
      [storageKey]="''"
      [toggleFilter]="toggleFilter"
      [filtersParams]="filtersParams"
      [defaultParams]="defaultTableParams"
    ></list-table-without-filters-wrapper>
  }
}
